<template>
  <div v-for="item in services" class="d-flex justify-content-between p-5 mt-4 box--gray mb-4">
    <div class="d-flex">
      <div class="checkbox d-flex align-items-center">
        <input
            :id="'check_gift_pack' + item.id"
            :checked="selectedServices.includes(item.id)"
            :disabled="inProgress"
            :name="'check_gift_pack' + item.id"
            class="checkbox__input"
            type="checkbox"
            @change="toggle(item.id)"
        >
        <label :for="'check_gift_pack' + item.id" class="checkbox__label">
          <b>{{ item.title }}</b>
          <span v-if="item.short_description">
            - {{ item.short_description }}
          </span>
        </label>
      </div>
    </div>
    <div>
      <b>{{ item.prices.current_formatted_price_with_tax }}</b>
    </div>
  </div>
</template>

<script>
export default {
  name:     "Services",
  props:    {
    cart:       {
      type: Object
    },
    in18:       {
      type: Object
    },
    services:   {
      type: Array
    },
    inProgress: {
      type: Boolean
    },
  },
  computed: {
    selectedServices() {
      return this.cart.items.map(el => el.product.id);
    }
  },

  emits: [
    'update-cart',
    'update-in-progress'
  ],

  methods: {

    toggle(productId) {

      if (this.inProgress) {
        return;
      }

      this.$emit('update-in-progress', true);

      const item = this.cart.items.find(el => el.product.id === productId);

      if (item) {
        axios.post('/api/cart-item/' + item.id + '/delete')
            .then((response) => {
              window.toastr.success(response.data.message);
              this.$emit('update-cart', response.data.cart);
              $('#cart-items-count').text(response.data.cart.total_quantity);
            })
            .catch((error) => {
              window.toastr.error(error.response.data.message);
            })
            .finally(() => {
              this.$emit('update-in-progress', false);
            });

      } else {
        axios.post('/api/cart-item/add/' + productId, {
          'quantity': 1
        })
            .then((response) => {
              window.toastr.success(response.data.message);
              this.$emit('update-cart', response.data.cart);
              $('#cart-items-count').text(response.data.cart.total_quantity);
            })
            .catch((error) => {
              window.toastr.error(error.response.data.message);
              console.error(error.response);
            })
            .finally(() => {
              this.$emit('update-in-progress', false);
            });
      }
    }
  }
}
</script>